// extracted by css-extract-rspack-plugin
export default {"authPage":"src-modules-auth-templates-AuthPageTemplate-AuthPageTemplate-module__authPage-ZmoYT_","content":"src-modules-auth-templates-AuthPageTemplate-AuthPageTemplate-module__content-BQCJP2","contentInner":"src-modules-auth-templates-AuthPageTemplate-AuthPageTemplate-module__contentInner-_vT00T","backButton":"src-modules-auth-templates-AuthPageTemplate-AuthPageTemplate-module__backButton-M_FHBg"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"authPage\":\"src-modules-auth-templates-AuthPageTemplate-AuthPageTemplate-module__authPage-ZmoYT_\",\"content\":\"src-modules-auth-templates-AuthPageTemplate-AuthPageTemplate-module__content-BQCJP2\",\"contentInner\":\"src-modules-auth-templates-AuthPageTemplate-AuthPageTemplate-module__contentInner-_vT00T\",\"backButton\":\"src-modules-auth-templates-AuthPageTemplate-AuthPageTemplate-module__backButton-M_FHBg\"}";
        // 1793875576591
        var cssReload = require("../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  